import React, { Component } from "react";
import Badge from 'react-bootstrap/Badge';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

export default class Header extends Component {

  constructor(props) {

    super(props);

    let jwt = localStorage.getItem('jwt');
    var logged = false;

    if (jwt) {
      logged = true;
    }

    this.state = {
      logged: logged,
    }

  }

  render() { 
    return (
      <Navbar bg="dark" expand="lg">
        <Container>
          <Navbar.Brand href="/"><img src={require('../resources/images/fmf-logo-64.png')} alt="Fmf Logo" className="fmf-logo"/> Find my friends <Badge className="em05" bg="secondary">BETA</Badge> </Navbar.Brand> 
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="flex-grow-0">
            <Nav>
              <Nav.Link href="/about">About</Nav.Link>
              {this.state.logged ?  <Nav.Link href="/logout"><i className="bi bi-box-arrow-right"></i> Logout</Nav.Link> : ""}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}
